// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonClose_container__2_Zxt","inner":"ButtonClose_inner__3dCYK","invert":"ButtonClose_invert__3rcgl","fixed":"ButtonClose_fixed__1rxsZ"};